import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import styles from '@jobcase/react_pattern_library/styles/rebrand';

import actions from '../../redux/nodes/authentication/actions';
import { getLoginError } from '../../redux/nodes/authentication/selectors';

import Alert from './Alert';
import LinkedInOAuth from '../LinkedInOAuth/LinkedInOAuth';

import { useSelector } from '../../utils/hooks';

const SocialSignInWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;

  [class*="Notification__BaseNotification"] {
    width: 100%;

    @media screen and (min-width: ${styles.breakpoint.md}){
      width: 336px;
    }
  }
`;


// TODO: Return below
// <GoogleOneTap
//   useOneTap={false}
//   onLoginSuccess={onLoginSuccess}
//   isLogin={isLogin}
// />
const SocialSignIn = ({ onLoginSuccess, isLogin, isLoginVisible }) => {
  const dispatch = useDispatch();
  const error = useSelector(getLoginError);

  useEffect(() => {
    dispatch({
      type: actions.TYPES.SET_LOGIN_ERROR,
      payload: null,
    });
  }, []);

  return (
    <SocialSignInWrapper>
      {
        !isLoginVisible
          ? !isLogin && typeof error === 'string' && <Alert alert={error} />
          : null
      }
      {/* TODO: return Google here */}
      <LinkedInOAuth onLoginSuccess={onLoginSuccess} />
    </SocialSignInWrapper>
  );
};


SocialSignIn.propTypes = {
  isLogin: PropTypes.bool,
  isLoginVisible: PropTypes.bool,
  onLoginSuccess: PropTypes.func,
};

SocialSignIn.defaultProps = {
  onLoginSuccess: null,
  isLogin: false,
  isLoginVisible: false,
};

export default SocialSignIn;
